import React, { useState } from 'react';
import './App.css';

function App() {
  const [currentSection, setCurrentSection] = useState(0);
  const [responses, setResponses] = useState({});
  const [showResult, setShowResult] = useState(false);

  const sections = [
    {
      title: "Gestão Financeira",
      questions: [
        { id: 'fin1', text: 'A empresa possui controle de fluxo de caixa atualizado diariamente?', weight: 3 },
        { id: 'fin2', text: 'Há conciliação bancária realizada mensalmente?', weight: 3 },
        { id: 'fin3', text: 'A empresa possui DRE (Demonstração do Resultado do Exercício) mensal?', weight: 3 },
        { id: 'fin4', text: 'Existe controle de contas a pagar e receber?', weight: 2 },
        { id: 'fin5', text: 'A empresa monitora indicadores financeiros (margem, EBITDA, etc.)?', weight: 3 }
      ]
    },
    {
      title: "Gestão Operacional",
      questions: [
        { id: 'op1', text: 'A empresa possui processos operacionais documentados?', weight: 2 },
        { id: 'op2', text: 'Há controle de qualidade dos produtos/serviços?', weight: 3 },
        { id: 'op3', text: 'Existe gestão de estoque (quando aplicável)?', weight: 2 },
        { id: 'op4', text: 'A empresa monitora indicadores de produtividade?', weight: 2 },
        { id: 'op5', text: 'Há sistema de gestão integrado (ERP)?', weight: 3 }
      ]
    },
    {
      title: "Gestão de Pessoas",
      questions: [
        { id: 'rh1', text: 'A empresa possui organograma definido?', weight: 2 },
        { id: 'rh2', text: 'Há descrição de cargos e responsabilidades?', weight: 2 },
        { id: 'rh3', text: 'Existe programa de treinamento e desenvolvimento?', weight: 3 },
        { id: 'rh4', text: 'A empresa realiza avaliação de desempenho?', weight: 2 },
        { id: 'rh5', text: 'Há política de remuneração estruturada?', weight: 2 }
      ]
    },
    {
      title: "Marketing e Vendas",
      questions: [
        { id: 'mk1', text: 'A empresa possui estratégia de marketing definida?', weight: 3 },
        { id: 'mk2', text: 'Há controle do funil de vendas?', weight: 3 },
        { id: 'mk3', text: 'Existe análise da concorrência?', weight: 2 },
        { id: 'mk4', text: 'A empresa monitora satisfação dos clientes?', weight: 3 },
        { id: 'mk5', text: 'Há presença digital estruturada (site, redes sociais)?', weight: 2 }
      ]
    },
    {
      title: "Governança e Compliance",
      questions: [
        { id: 'gov1', text: 'A empresa possui missão, visão e valores definidos?', weight: 2 },
        { id: 'gov2', text: 'Há planejamento estratégico formalizado?', weight: 3 },
        { id: 'gov3', text: 'Existe compliance com regulamentações do setor?', weight: 3 },
        { id: 'gov4', text: 'A empresa possui políticas internas documentadas?', weight: 2 },
        { id: 'gov5', text: 'Há controles internos para prevenção de fraudes?', weight: 3 }
      ]
    }
  ];

  const handleResponse = (questionId, value) => {
    setResponses(prev => ({
      ...prev,
      [questionId]: value
    }));
  };

  const nextSection = () => {
    if (currentSection < sections.length - 1) {
      setCurrentSection(currentSection + 1);
    } else {
      generateDiagnostic();
    }
  };

  const prevSection = () => {
    if (currentSection > 0) {
      setCurrentSection(currentSection - 1);
    }
  };

  const generateDiagnostic = () => {
    setShowResult(true);
  };

  const calculateSectionScore = (sectionIndex) => {
    const section = sections[sectionIndex];
    let totalScore = 0;
    let maxScore = 0;

    section.questions.forEach(question => {
      const response = responses[question.id];
      if (response !== undefined) {
        totalScore += response * question.weight;
      }
      maxScore += 3 * question.weight; // Máximo é sempre 3
    });

    return { score: totalScore, maxScore, percentage: (totalScore / maxScore) * 100 };
  };

  const getOverallScore = () => {
    let totalScore = 0;
    let maxScore = 0;

    sections.forEach((_, index) => {
      const sectionResult = calculateSectionScore(index);
      totalScore += sectionResult.score;
      maxScore += sectionResult.maxScore;
    });

    return { score: totalScore, maxScore, percentage: (totalScore / maxScore) * 100 };
  };

  const getRecommendation = (percentage) => {
    if (percentage >= 80) {
      return {
        level: "Excelente",
        color: "#22c55e",
        description: "Sua empresa demonstra excelência nesta área. Continue mantendo os altos padrões e busque inovações para se manter à frente da concorrência."
      };
    } else if (percentage >= 60) {
      return {
        level: "Bom",
        color: "#3b82f6",
        description: "Sua empresa está bem estruturada nesta área, mas há oportunidades de melhoria que podem gerar resultados ainda melhores."
      };
    } else if (percentage >= 40) {
      return {
        level: "Regular",
        color: "#f59e0b",
        description: "Esta área precisa de atenção. Implementar melhorias aqui pode trazer impactos significativos para o negócio."
      };
    } else {
      return {
        level: "Crítico",
        color: "#ef4444",
        description: "Esta área requer ação imediata. É fundamental implementar controles e processos para reduzir riscos e melhorar a performance."
      };
    }
  };

  if (showResult) {
    const overallResult = getOverallScore();
    
    return (
      <div className="App">
        <header className="app-header">
          <img src="/oito-leme-logo.png" alt="Oito Leme" className="logo" />
          <h1 className="main-title">
            DIAGNÓSTICO EMPRESARIAL
            <span className="subtitle">COMPLETO</span>
          </h1>
        </header>

        <main className="main-content">
          <div className="result-container">
            <div className="overall-score">
              <h2>Resultado Geral</h2>
              <div className="score-circle">
                <span className="score-number">{Math.round(overallResult.percentage)}%</span>
                <span className="score-label">Maturidade Empresarial</span>
              </div>
            </div>

            <div className="sections-results">
              {sections.map((section, index) => {
                const sectionResult = calculateSectionScore(index);
                const recommendation = getRecommendation(sectionResult.percentage);
                
                return (
                  <div key={index} className="section-result">
                    <div className="section-header">
                      <h3>{section.title}</h3>
                      <div 
                        className="section-score"
                        style={{ backgroundColor: recommendation.color }}
                      >
                        {Math.round(sectionResult.percentage)}%
                      </div>
                    </div>
                    <div className="section-recommendation">
                      <span className="level" style={{ color: recommendation.color }}>
                        {recommendation.level}
                      </span>
                      <p>{recommendation.description}</p>
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="action-section">
              <h3>Próximos Passos</h3>
              <p>
                Com base no seu diagnóstico, nossa equipe pode ajudar a implementar as melhorias necessárias 
                para elevar o nível de maturidade da sua empresa. Entre em contato para uma consultoria personalizada.
              </p>
              
              <div className="action-buttons">
                <a 
                  href="https://api.whatsapp.com/message/NTW4QJ2OJSX5I1?autoload=1&app_absent=0" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="whatsapp-btn"
                >
                  📱 Falar com Especialista
                </a>
                
                <a 
                  href="https://www.oitoleme.com.br" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="learn-more-btn"
                >
                  🔗 Saiba mais
                </a>
              </div>
            </div>
          </div>
        </main>

        <footer className="app-footer">
          <p>Deslize para cima para ver o oitoleme.com.br</p>
        </footer>
      </div>
    );
  }

  const currentSectionData = sections[currentSection];
  const progress = ((currentSection + 1) / sections.length) * 100;

  return (
    <div className="App">
      <header className="app-header">
        <img src="/oito-leme-logo.png" alt="Oito Leme" className="logo" />
        <h1 className="main-title">
          DIAGNÓSTICO EMPRESARIAL
          <span className="subtitle">COMPLETO</span>
        </h1>
      </header>

      <main className="main-content">
        <div className="progress-bar">
          <div className="progress-fill" style={{ width: `${progress}%` }}></div>
        </div>
        
        <div className="section-info">
          <h2>{currentSectionData.title}</h2>
          <p>Seção {currentSection + 1} de {sections.length}</p>
        </div>

        <div className="questionnaire">
          {currentSectionData.questions.map((question, index) => (
            <div key={question.id} className="question-item">
              <p className="question-text">{question.text}</p>
              <div className="options">
                {[
                  { value: 0, label: 'Não' },
                  { value: 1, label: 'Parcialmente' },
                  { value: 2, label: 'Em desenvolvimento' },
                  { value: 3, label: 'Sim, totalmente' }
                ].map(option => (
                  <label key={option.value} className="option-label">
                    <input
                      type="radio"
                      name={question.id}
                      value={option.value}
                      checked={responses[question.id] === option.value}
                      onChange={(e) => handleResponse(question.id, parseInt(e.target.value))}
                    />
                    <span className="option-text">{option.label}</span>
                  </label>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="navigation-buttons">
          {currentSection > 0 && (
            <button className="nav-btn prev-btn" onClick={prevSection}>
              ← Anterior
            </button>
          )}
          
          <button className="nav-btn next-btn" onClick={nextSection}>
            {currentSection === sections.length - 1 ? 'Gerar Diagnóstico' : 'Próxima →'}
          </button>
        </div>
      </main>

      <footer className="app-footer">
        <p>Deslize para cima para ver o oitoleme.com.br</p>
      </footer>
    </div>
  );
}

export default App;
